module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[18]383.22b5059.woff2";